module.exports = __webpack_public_path__ + "static/media/Soleil-Italic.4953a687.otf";